export default [
  {
    label: "Usuários",
    to: "/administration/users",
    icon: "fas fa-user-cog",
    controller: "UserInternal",
    action: "List"
  },
  {
    separator: true
  },
  // {
  //   label: "Chamados",
  //   to: "/administration/tickets",
  //   icon: "fas fa-ticket-alt",
  //   controller: "Ticket",
  //   action: "List"
  // },
  // {
  //   separator: true
  // },
  // {
  //   label: "Gerenciamento de mudanças",
  //   to: "/administration/change-management",
  //   icon: "fas fa-tasks",
  //   controller: "ChangeManagement",
  //   action: "List"
  // },
  // {
  //   separator: true
  // },
  // {
  //   label: "Calculadora de comissões",
  //   to: "/administration/calculator",
  //   icon: "fas fa-calculator",
  //   controller: "CommissionCompetence",
  //   action: "ListCalculator"
  // },
  // {
  //   separator: true
  // },
  {
    label: "Central de downloads",
    to: "/administration/downloads",
    icon: "fas fa-arrow-down",
    controller: "Document",
    action: "List"
  },
  {
    separator: true
  },
  {
    label: "Gerador de assinaturas",
    to: "/administration/signatures",
    icon: "fas fa-signature",
    isAuthorize: true
  },
  {
    separator: true
  },
  {
    label: "Templates de e-mail",
    to: "/administration/template-emails",
    icon: "fas fa-envelope",
    controller: "TemplateEmail",
    action: "List"
  },
  {
    separator: true
  },
  {
    label: "E-mails em massa",
    to: "/administration/emailing",
    icon: "fas fa-mail-bulk",
    controller: "Emailing",
    action: "List"
  },
  // {
  //   label: "Limites",
  //   to: "/administration/limits",
  //   icon: "far fa-credit-card",
  //   controller: "Limits",
  //   action: "List"
  // },
  {
    label: "Parâmetros",
    to: "/administration/parameters",
    icon: "fa fa-clipboard-list",
    controller: "BusinessParameter",
    action: "List"
  },
  {
    separator:true
  },
  {
    label: "Operadores",
    to: "/administration/operators",
    icon: "fas fa-user-lock",
    controller: "Operator",
    action: "List"
  }
];




// WEBPACK FOOTER //
// ./src/data/menu-item-internal/administration-menu.js